<template>

  <div class="privacy_agreement">
    <div class="swiper-slide swiper_md">
      <h3 class="ys_title">隐私政策</h3>
      <p class="label ys_date">2023年02月17日</p>
      <p class="label ys_txt"><span
          class="ys_indent2">本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。</span>
      </p>
      <p class="label ys_stage">一、适用范围</p>
      <p class="label ys_txt"><span class="ys_indent2">1.本应用在使用过程中，不会收集任何设备或用户使用行为的信息，也不存在把数据提供给第三方的问题。</span>
      </p>
      <p class="label  ys_txt"><span class="ys_indent2">2.在您使用本应用时输入记录的信息，只存在于本机设备，数据完全由用户管理，包括转移、删除等，完全由用户决定。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">3.本应用不需要用户登录即可使用。</span></p>
      <p class="label ys_stage">您了解并同意，以下信息不适用本隐私权政策：</p>
      <p class="label ys_txt"><span class="ys_indent2">1.您在使用本应用平台提供的搜索服务时输入的关键字信息.</span>
      </p>
      <p class="label  ys_txt"><span class="ys_indent2">2.本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情.</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">3.违反法律规定或违反本应用规则行为及本应用已对您采取的措施。</span></p>
      <p class="label ys_stage">二、信息使用</p>
      <p class="label ys_txt"><span
          class="ys_indent2">1.本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</span>
      </p>
      <p class="label ys_txt"><span
          class="ys_indent2">2.本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。</span>
      </p>
      <p class="label ys_stage">三、信息披露</p>
      <p class="label ys_stage">在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
      <p class="label ys_txt"><span class="ys_indent2">1. 经您事先同意，向第三方披露； </span></p>
      <p class="label ys_txt"><span class="ys_indent2">2.根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">3.如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">4.如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</span>
      </p>
      <p class="label ys_txt"><span
          class="ys_indent2">5.在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决；</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">6.其它本应用根据法律、法规或者网站政策认为合适的披露；
        </span></p>
      <p class="label ys_stage">四、信息存储和交换</p>
      <p class="label ys_txt"><span class="ys_indent2"> 本应用收集的有关您的信息和资料将保存在本应用本地设备。</span></p>
      <p class="label ys_stage">五、信息安全</p>
      <p class="label ys_txt"><span class="ys_indent2">本应用不涉及网络，即使本地账号也仅仅是区分不同用户。所以安全风险较小。数据由用户管理。</span>
      </p>
      <p class="label ys_stage">六、开发者信息</p>
      <p class="label ys_txt"><span class="ys_indent2">本隐私政策适用于开发者——仙桃市天翔置业有限公司公司旗下精品二手车展厅小程序。如有疑问，请致电：0728-3310876。
        </span>
      </p>
    </div>
  </div>

</template>

<script>
  export default {
    name: "privacy_agreement",

  };
</script>
<style lang="scss" scoped>
  .privacy_agreement {
    color: #333;
    margin: 0;
    padding: 0;
    border: 0;
    list-style: none;
    outline-style: none;
    font-family: Microsoft Yahei;
    padding: 25px 18px 18px;
    font-size: 14px;
    height: 100%;
    overflow-y: scroll;
    text-align: left;

    .label {
      display: flex;
    }

    .ys_title {
      font-size: 19px;
      color: #000;
      text-align: center;
      font-weight: bold;
      margin: 0;
    }

    .ys_date {
      margin-top: 19.5px;
      margin-bottom: 10px;
      display: block;
      text-align: right;
      font-size: 12px;
      color: #000;
    }

    .ys_txt {
      margin-top: 2px !important;
      margin-bottom: 0;
    }

    .ys_indent2 {
      text-indent: 19px;
      color: #000;
    }

    .ys_stage {
      color: #000;
      font-weight: bold;
      margin-bottom: 15px;
      text-align: left;
    }

    .ys_indent3 {
      text-indent: 19px;
      color: #000;
      font-weight: 500;
      text-align: left;
      margin-bottom: 5px;
      display: block;
    }

    .label span {
      line-height: 23px;
    }

    .ys_indent4 {
      text-indent: 30px;
      color: #000;
    }

    .ys_indent5 {
      text-indent: 24px;
      color: #000;
      margin-bottom: 3px;
    }

  }
</style>